import React from 'react';
import { AttachmentContainer, StyledDialog, Attachment, CloseModalButton, } from '../styles';
import Button from 'src/Components/Common/AdminButton/Button';
import { exit } from '../../../assets/Images';
export default function AttachmentsModal(_a) {
    var _b;
    var files = _a.files, open = _a.open, onClose = _a.onClose;
    var handleAttachmentClick = function (url) {
        window.open(url, '_blank');
    };
    var content = (_b = files === null || files === void 0 ? void 0 : files.map) === null || _b === void 0 ? void 0 : _b.call(files, function (file) { return (React.createElement(Attachment, { key: file.id },
        React.createElement("span", null, file.name),
        React.createElement(Button, { onClick: function () { return handleAttachmentClick(file.url); } }, "Ver"))); });
    return (React.createElement(StyledDialog, { onClose: onClose, open: open },
        React.createElement(AttachmentContainer, null,
            React.createElement("h3", null, "Documentos adjuntos"),
            content),
        React.createElement(CloseModalButton, { onClick: onClose, src: exit })));
}
